export default {
  name: 'marking--mrkStatusSystem',
};